import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { PATHS } from "../constants/paths";

const AuthenticatedGuard = () => {
  const token = localStorage.getItem("user_token");

  return token ? <Outlet /> : <Navigate to={PATHS.LOGIN} replace />;
};

export default AuthenticatedGuard;
